module.exports = __webpack_public_path__ + "img/text.1f82701b.png";